import { moneyRequestService } from '@/common/api.service'

const initialStates = {
    status: 'successReceiptData',
    paymentData: {},
    receiptData: {},
    detailItem: {
        status: 'loading',
        data: [],
    },
    detailCustomer: {
        status: 'loading',
        data: [],
    },
    detailCustomerFormat: {
        status: 'loading',
        data: [],
    },
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, paymentData) {
        state.status = 'success'
        state.paymentData = paymentData
    },
    receiptData(state, receiptData) {
        state.status = 'successReceiptData'
        state.receiptData = receiptData
    },
    showData(state, data) {
        state.detailItem.status = 'success'
        state.detailItem.data = data
    },
    showCustomerData(state, data) {
        state.detailCustomer.status = 'success'
        state.detailCustomer.data = data
    },
    showCustomerFormatData(state, data) {
        state.detailCustomerFormat.status = 'success'
        state.detailCustomerFormat.data = data
    },
}

const getters = {
    status: ({status}) => status,
    paymentData: ({paymentData}) => paymentData,
    receiptData: ({receiptData}) => receiptData,
    detailItem : ({detailItem}) => detailItem.data,
    detailCustomer : ({detailCustomer}) => detailCustomer.data,
    detailCustomerStatus : ({detailCustomer}) => detailCustomer.status,
    detailCustomerFormat : ({detailCustomerFormat}) => detailCustomerFormat.data,
    detailCustomerFormatStatus : ({detailCustomerFormat}) => detailCustomerFormat.status,
}

const actions = {
    find({commit}, tracking_code) {
        commit('loading')
        return moneyRequestService.find(tracking_code).then(response => {
            commit('success', response.data.data)
        })
    },
    receiptData({commit}, tracking_code) {
        commit('loading')
        return moneyRequestService.getReceiptData(tracking_code).then(response => {
            commit('receiptData', response.data.data)
        })
    },
    showItem({commit}, hashid) {
        commit('loading')
        return moneyRequestService.showItem(hashid).then(response => {
            commit('showData', response.data.data)
        })
    },
    showCustomer({commit}, hashid) {
        commit('loading')
        return moneyRequestService.showCustomer(hashid).then(response => {
            commit('showCustomerData', response.data.data)
        })
    },
    showCustomerFormat({commit}, hashid) {
        commit('loading')
        return moneyRequestService.showCustomerFormat(hashid).then(response => {
            commit('showCustomerFormatData', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}
